export const createRegex = (prefixes: string[]) => {
  const escapedPrefixes = prefixes.map((prefix) =>
    prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  );
  const pattern = `^(${escapedPrefixes.join("|")})\\d{6}$`;
  return new RegExp(pattern, "i");
};

const regex = createRegex(["PR", "BU", "RE"]);

export const validateString = (input: string) => {
  return regex.test(input);
};
